import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUTubeHeatExchanger = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 91.75,
	height: 30,
	viewBox: "0 0 91.75 30.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 15.0 24.0 L 15.0 30.0 L 0.0 30.0 L 0.0 0.0 L 15.0 0.0 L 15.0 6.0 L 85.0 6.0 A 6.0 8.0 0.0 0 1 85.0 24.0 L 15.0 24.0 Z M 15.0 6.0 L 15.0 24.0 M 0.0 15.0 L 15.0 15.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgUTubeHeatExchanger;
